import {reauthenticate} from "@onflow/fcl"

export const LABEL = "Log In"
export const CMD = reauthenticate
